import type { ReactNode } from 'react';

interface Props {
  title?: ReactNode;
  description?: ReactNode;
}

export function SectionHeader({ title, description }: Props) {
  return (
    <div className="space-y-1 px-6 pt-6">
      <h2 className="text-base-foreground text-xl font-semibold">{title}</h2>
      {description ? (
        <p className="text-base-muted-foreground text-sm font-normal">{description}</p>
      ) : null}
    </div>
  );
}
